import { useEffect } from "react"
import { Controller, useForm } from "react-hook-form"
import DropZone from "../../Common/DropZone/DropZone"
import CustomButton from "../../UI/CustomButton/CustomButton"
import Field from "../../UI/Field/Field"
import Input from "../../UI/Form/Input"
import Modal from "../../UI/Modal/Modal"
import classes from '../AdminForm.module.css'

const PartnerCreate = (props) => {
    const { onClose, addPartner } = props

    const { handleSubmit, reset, control } = useForm()

    const onSubmit = (data) => {
        console.log(data)
        addPartner(data)
    }

    useEffect(() => {
        reset({
            name: "",
            url: "",
            image: null
        })
    }, [])

    return (
        <Modal title="New Partner" onClose={onClose}>
            <form className={classes.main} onSubmit={handleSubmit(onSubmit)}>
                <Field>
                    <Controller
                        name="name"
                        control={control}
                        defaultValue=""
                        rules={{ required: "Required Field!" }}
                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                            <Input
                                onChange={onChange}
                                value={value}
                                error={error}
                                label="Partner name"  
                            />
                        )}
                    />
                </Field>
                <Field>
                    <Controller
                        name="url"
                        control={control}
                        defaultValue=""
                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                            <Input
                                onChange={onChange}
                                value={value}
                                error={error}
                                label="Partner website"  
                            />
                        )}
                    />
                </Field>
                <div className={classes.imgContainer}>
                    <Controller
                        name={`image`}
                        control={control}
                        rules={{ required: "Required Field!" }}
                        defaultValue=""
                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                            <DropZone
                                onChange={onChange}
                                error={error}
                                title="Partner image"
                                id={1}
                            />
                        )}
                    />
                </div>
                <CustomButton type="submit">Add</CustomButton>
            </form>
        </Modal>
    )
}

export default PartnerCreate